import React, { Component } from 'react';
import StatelessSwitcher from '../../components/common/StatelessSwitcher';
import tracker from '../../services/tracker';
import { gaEvent, trackGA } from 'services/ga';

export default class Switcher extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isChecked: ('defaultChecked' in this.props) ? this.props.defaultChecked : true
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { onClick, events, eventData, gaEventName, gaEventData } = this.props;
    this.setState({ isChecked: !this.state.isChecked }, () => {
      tracker.sendEvent(this.state.isChecked ? events.left : events.right, eventData);
      this.handleTrackEvent({
        eventName: gaEventName,
        eventLabel: this.state.isChecked ? gaEventData.left : gaEventData.right
      });
      onClick(this.state.isChecked);
    });
  }


  handleTrackEvent = ({ eventName, eventLabel }) => {
    const { buildingData, objectType, profile } = this.props;
    const { title, id } = buildingData;

    trackGA(gaEvent[eventName]({
      eventLabel,
      productType: objectType,
      productName: title,
      productID: id,
      user_id: profile.id
    }));
  };

  render() {
    return (
      <StatelessSwitcher
        {...this.props}
        onClick={this.handleClick}
        isChecked={this.state.isChecked}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Switcher/Switcher.js